export default __webpack_public_path__ + "static/media/isuzu.86cced88.png";